import React from "react";
import {withRouter, Link} from 'react-router-dom';
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import GenericButton from "../GenericButton";

const PublishWithAdvancedOptionsLink = ({history, disabled}) => {
  const handleClick = () => {
    history.push(`/targeting?lastLocation=${window.location.pathname}`);
  };

  return (
    <div className={container}>
      <GenericButton
        text="Publish With Advanced Options &nbsp;&rarr;"
        style="button save"
        handleClick={handleClick}
        disabled={disabled}
      />
    </div>
  );
};

export default withRouter(PublishWithAdvancedOptionsLink);

const container = css`
  width: 100%;

  .save {
      border-radius: 40px;
      border: 2px solid ${colors.brandColor};
      color: ${colors.brandColor};
      font-size: ${textSizes.intermediate};
      background-color: transparent;
      font-weight: bold;
      padding: 8px;
      cursor: pointer;
    }
  
  a {
    text-decoration: none;
  }

  .optionsRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    position: relative;
    
    p {
      font-size: ${textSizes.intermediate};
      color: ${colors.titleColor};
    }
    
    .icon {
      color: ${colors.chevronColor};
    }
  }
`;
